// extracted by mini-css-extract-plugin
export var standaloneTable = "_in-0";
export var standaloneTableWithBodyFill = "_in-1";
export var withExtraHeader = "_in-2";